module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-choose"
  }, _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "choose-detail-item",
      on: {
        "click": function($event) {
          return _vm.chooseItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "choose-detail"
    }, [_c('span', {
      class: {
        'title-tip': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "select-tip",
      class: {
        'title-tip': !item.hasSelected, 'selected-text': item.hasSelected, 'error': item.isError && !item.hasSelected
      }
    }, [_vm._v(_vm._s(item.selectedText))])])])
  }), 0), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-top"
  }, [_c('div', {
    staticClass: "user-choose"
  }, _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "choose-detail-item",
      class: {
        active: _vm.selectedItem === index
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "choose-detail"
    }, [_c('span', {
      class: {
        'title-tip': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      class: {
        'title-tip': !item.hasSelected, 'selected-text': item.hasSelected
      }
    }, [_vm._v(_vm._s(item.selectedText))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.multSelectArray[_vm.selectedItem].title))]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.nextSelect(_vm.selectedItem)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _vm._l((_vm.multSelectArray), function(item, index) {
    return _c('select-scroll', {
      key: index,
      attrs: {
        "dataList": item.list,
        "selectedIndex": item.selectedIndex,
        "show": _vm.showBox && index === _vm.selectedItem
      },
      on: {
        "scrollEnd": _vm.scrollEnd
      }
    })
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dfafaaa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/experience/index.vue
// module id = 334
// module chunks = 0